// extracted by mini-css-extract-plugin
export default {"carousel-slide-container":"Carrousel_carousel-slide-container__q7guj"};